// extracted by mini-css-extract-plugin
export default {"productList":"product-list_productList__Pe4qz","empty":"product-list_empty__WpGfb","rotate":"product-list_rotate__zyNT5"};